import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQuery } from "@/lib/api/queries";

/**
 * "/" sends the user to their first workspace; the workspace index picks the project. A user
 * who belongs to none goes to the front door, where their invitations wait and a workspace
 * can be created — never to a dead end.
 */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery());
    const ws = me.workspaces[0];
    if (!ws) throw redirect({ to: "/workspaces/new" });
    throw redirect({ to: "/w/$workspace", params: { workspace: ws.slug } });
  },
});
